import { render, staticRenderFns } from "./MyPageMenu.vue?vue&type=template&id=2a94691f&scoped=true"
import script from "./MyPageMenu.vue?vue&type=script&lang=js"
export * from "./MyPageMenu.vue?vue&type=script&lang=js"
import style0 from "./MyPageMenu.vue?vue&type=style&index=0&id=2a94691f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a94691f",
  null
  
)

export default component.exports